import moment from "moment/moment";

import {
    DATE_RANGE_ANY, DATE_RANGE_CUSTOM,
    DATE_RANGE_LAST_30_DAYS,
    DATE_RANGE_LAST_7_DAYS, DATE_RANGE_LAST_90_DAYS,
    DATE_RANGE_TODAY,
    DATE_RANGE_YESTERDAY
} from "../../../constants/dates";

export const getRangeFromDates = function (from, till) {
    if (!from && !till) {
        return DATE_RANGE_ANY;
    }
    if (from === moment().startOf('day').unix() && till === moment().endOf('day').unix()) {
        return DATE_RANGE_TODAY;
    }
    if (from === moment().subtract(1, 'd').startOf('day').unix() && till === moment().subtract(1, 'd').endOf('day').unix()) {
        return DATE_RANGE_YESTERDAY;
    }
    if (from === moment().subtract(7, 'd').startOf('day').unix() && till === moment().endOf('day').unix()) {
        return DATE_RANGE_LAST_7_DAYS;
    }
    if (from === moment().subtract(30, 'd').startOf('day').unix() && till === moment().endOf('day').unix()) {
        return DATE_RANGE_LAST_30_DAYS;
    }
    if (from === moment().subtract(90, 'd').startOf('day').unix() && till === moment().endOf('day').unix()) {
        return DATE_RANGE_LAST_90_DAYS;
    }

    return DATE_RANGE_CUSTOM;
}
